import { render, staticRenderFns } from "./ModalSukses.vue?vue&type=template&id=76d2baff&"
import script from "./ModalSukses.vue?vue&type=script&lang=js&"
export * from "./ModalSukses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports